import React, { Component, Fragment  } from 'react';
import './DetallesActivo.css'; 
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import TextField from '@material-ui/core/TextField';
import MyButton from '../../../utils/MyButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';

import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import CircularProgress from '@material-ui/core/CircularProgress';

import { FaArrowLeft,FaPlus, FaPencilAlt, FaCheck, FaCheckCircle } from "react-icons/fa";

import {  clearErrors, editActivoDetails, getActivo } from '../../../redux/actions/mobiliarioactions';

export class DetallesActivo extends Component {
  
    constructor(){
        super();
        this.state={
            nombre:'',
            marca:'',
            
            modelo:'',
            serie:'',
            ubicacion:'',
            servicio:'',
            tipo:'',
            
            movilfijo:'',
           
            reqcalibracion:'',
            adquisicion:'',
            costo:'',
            fabricacion:'',
            fechaadquisicion:'',
            vidautil:'',
            proveedor:'',
            proveedortel:'',
            proveedoremail:'',
            tipotec:'',
            fuente:'',
            tensionmin:'',
            tensionmax:'',
            corrientemin:'',
            corrientemax:'',
            temperatura:'',
            frecuencia:'',
            potencia:'',
            presion:'',
            alto:'',
            ancho:'',
            largo:'',
            peso:'',
            idinventario:'',
            urlfactura:'',
            urlmanual:'',
            urlimportacion:'',
            urlmanualuser:'',
            errors:{},
            aprobado:{},
             // New variables
             fechainstalacion: '',
             garantia: '',
             fechainiciogarantia: '',
             fechafingarantia: '',
             velocidad: '',
             capacidad: '',
             tipouso: '',
             pais: '',
             descripcion: '',
             nombrefabricante: '',
             emailfabricante: '',
             telfabricante: '',
             rutinamto: '',
             recomendaciones: '',
             accesorio: '',
             accesorionombre1: '',
             accesorioref1: '',
             accesorioserie1: '',
             accesorionombre2: '',
             accesorioref2: '',
             accesorioserie2: '',
             accesorionombre3: '',
             accesorioref3: '',
             accesorioserie3: '',
            open:false
        };
        
    };
    static getDerivedStateFromProps(props, state) {
      const newState = {};
  
      if (props.UI.errors) {
          newState.errors = props.UI.errors;
      }
  
      if (props.UI.aprobado) {
         newState.aprobado = props.UI.aprobado;
      }
  
      return Object.keys(newState).length > 0 ? newState : null;
  }
      
  formatearFecha = (fecha) => {
    if (!fecha) return '';
    const partes = fecha.split('/');
    if (partes.length !== 3) return fecha;
    const [dia, mes, año] = partes;
    return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
  };

  mapUserDetailsToState = (mobiliario) => {
    this.setState({
        nombre:mobiliario.nombre?mobiliario.nombre:'',
        marca:mobiliario.marca?mobiliario.marca:'',
             modelo:mobiliario.modelo?mobiliario.modelo:'',
            serie:mobiliario.serie?mobiliario.serie:'',
            ubicacion:mobiliario.ubicacion?mobiliario.ubicacion:'',
            servicio:mobiliario.servicio?mobiliario.servicio:'',
            tipo:mobiliario.tipo?mobiliario.tipo:'',
           
            movilfijo:mobiliario.movilfijo?mobiliario.movilfijo:'',
           
            reqcalibracion:mobiliario.reqcalibracion?mobiliario.reqcalibracion:'',
            adquisicion:mobiliario.adquisicion?mobiliario.adquisicion:'',
            costo:mobiliario.costo?mobiliario.costo:'',
            vidautil:mobiliario.vidautil?mobiliario.vidautil:'',
            proveedor:mobiliario.proveedor?mobiliario.proveedor:'',
            proveedortel:mobiliario.proveedortel?mobiliario.proveedortel:'',
            proveedoremail:mobiliario.proveedoremail?mobiliario.proveedoremail:'',
            tipotec:mobiliario.tipotec?mobiliario.tipotec:'',
            fuente:mobiliario.fuente?mobiliario.fuente:'',
            tensionmin:mobiliario.tensionmin?mobiliario.tensionmin:'',
            tensionmax:mobiliario.tensionmax?mobiliario.tensionmax:'',
            corrientemin:mobiliario.corrientemin?mobiliario.corrientemin:'',
            corrientemax:mobiliario.corrientemax?mobiliario.corrientemax:'',
            temperatura:mobiliario.temperatura?mobiliario.temperatura:'',
            frecuencia:mobiliario.frecuencia?mobiliario.frecuencia:'',
            presion:mobiliario.presion?mobiliario.presion:'',
            potencia:mobiliario.potencia?mobiliario.potencia:'',
            alto:mobiliario.alto?mobiliario.alto:'',
            ancho:mobiliario.ancho?mobiliario.ancho:'',
            largo:mobiliario.largo?mobiliario.largo:'',
            peso:mobiliario.peso?mobiliario.peso:'',
            idinventario:mobiliario.idinventario?mobiliario.idinventario:'',
            urlfactura:mobiliario.urlfactura?mobiliario.urlfactura:'',
            urlmanual:mobiliario.urlmanual?mobiliario.urlmanual:'',
            urlmanualuser:mobiliario.urlmanualuser?mobiliario.urlmanualuser:'',
            urlimportacion:mobiliario.urlimportacion?mobiliario.urlimportacion:'',
             // Map new variables
             fechainstalacion: mobiliario.fechainstalacion ? this.formatearFecha(mobiliario.fechainstalacion) : '',
            fechainiciogarantia: mobiliario.fechainiciogarantia ? this.formatearFecha(mobiliario.fechainiciogarantia) : '',
            fechafingarantia: mobiliario.fechafingarantia ? this.formatearFecha(mobiliario.fechafingarantia) : '',
            fabricacion: mobiliario.fabricacion ? this.formatearFecha(mobiliario.fabricacion) : '',
            fechaadquisicion: mobiliario.fechaadquisicion ? this.formatearFecha(mobiliario.fechaadquisicion) : '',
              garantia: mobiliario.garantia ? mobiliario.garantia : '',
             velocidad: mobiliario.velocidad ? mobiliario.velocidad : '',
             capacidad: mobiliario.capacidad ? mobiliario.capacidad : '',
             tipouso: mobiliario.tipouso ? mobiliario.tipouso : '',
             pais: mobiliario.pais ? mobiliario.pais : '',
             descripcion: mobiliario.descripcion ? mobiliario.descripcion : '',
             nombrefabricante: mobiliario.nombrefabricante ? mobiliario.nombrefabricante : '',
             emailfabricante: mobiliario.emailfabricante ? mobiliario.emailfabricante : '',
             telfabricante: mobiliario.telfabricante ? mobiliario.telfabricante : '',
             rutinamto: mobiliario.rutinamto ? mobiliario.rutinamto : '',
             recomendaciones: mobiliario.recomendaciones ? mobiliario.recomendaciones : '',
             accesorio: mobiliario.accesorio ? mobiliario.accesorio : '',
             accesorionombre1: mobiliario.accesorionombre1 ? mobiliario.accesorionombre1 : '',
             accesorioref1: mobiliario.accesorioref1 ? mobiliario.accesorioref1 : '',
             accesorioserie1: mobiliario.accesorioserie1 ? mobiliario.accesorioserie1 : '',
             accesorionombre2: mobiliario.accesorionombre2 ? mobiliario.accesorionombre2 : '',
             accesorioref2: mobiliario.accesorioref2 ? mobiliario.accesorioref2 : '',
             accesorioserie2: mobiliario.accesorioserie2 ? mobiliario.accesorioserie2 : '',
             accesorionombre3: mobiliario.accesorionombre3 ? mobiliario.accesorionombre3 : '',
             accesorioref3: mobiliario.accesorioref3 ? mobiliario.accesorioref3 : '',
             accesorioserie3: mobiliario.accesorioserie3 ? mobiliario.accesorioserie3 : ''
            
    });
  };

  handleOpen = () => {
    this.setState({ open: true,errors:{},
      aprobado:{}});
    this.mapUserDetailsToState(this.props.mobiliario);
  };
  handleClose = () => {
    if (this.state.aprobado && this.state.aprobado.mensaje) {
        // Si la edición fue exitosa, actualizar el mobiliario
        this.props.getActivo(this.props.mobiliarioId);
        
        // Reiniciar el estado
        this.setState({
            open: false,
            errors: {},
            aprobado: {}
        });
        this.props.clearErrors();
    } else {
        // Si no se completó la edición o hubo un error
        this.props.clearErrors();
        this.setState({
            open: false,
            errors: {},
            aprobado: {}
        });
    }
};
  componentDidMount() {
    const { mobiliario } = this.props;
    this.mapUserDetailsToState(mobiliario);
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    
    // Special handling for warranty and accessory fields
    if (name === 'garantia' && value === 'false') {
        // If warranty is set to false, clear warranty dates
        this.setState({
            [name]: value,
            fechainiciogarantia: '',
            fechafingarantia: ''
        });
    } else if (name === 'accesorio' && value === 'false') {
        // If accessories is set to false, clear all accessory fields
        this.setState({
            [name]: value,
            accesorionombre1: '',
            accesorioref1: '',
            accesorioserie1: '',
            accesorionombre2: '',
            accesorioref2: '',
            accesorioserie2: '',
            accesorionombre3: '',
            accesorioref3: '',
            accesorioserie3: ''
        });
    } else {
        // Default handling for all other fields
        this.setState({ [name]: value });
    }
};
  handleSubmit = (event) => {
    event.preventDefault();
            const newmobiliarioData={
                nombre:this.state.nombre,
                marca:this.state.marca,
                
                modelo:this.state.modelo,
                serie:this.state.serie,
                ubicacion:this.state.ubicacion,
                servicio:this.state.servicio,
                tipo:this.state.tipo,
                
                movilfijo:this.state.movilfijo,
              
                reqcalibracion:this.state.reqcalibracion,
                adquisicion:this.state.adquisicion,
                costo:this.state.costo,
                fabricacion:this.state.fabricacion,
                fechaadquisicion:this.state.fechaadquisicion,
                vidautil:this.state.vidautil,
                proveedor:this.state.proveedor,
                proveedortel:this.state.proveedortel,
                proveedoremail:this.state.proveedoremail,
                tipotec:this.state.tipotec,
                fuente:this.state.fuente,
                tensionmin:this.state.tensionmin,
                tensionmax:this.state.tensionmax,
                corrientemin:this.state.corrientemin,
                corrientemax:this.state.corrientemax,
                frecuencia:this.state.frecuencia,
                temperatura:this.state.temperatura,
                presion:this.state.presion,
                potencia:this.state.potencia,
                alto:this.state.alto,
                ancho:this.state.ancho,
                largo:this.state.largo,
                peso:this.state.peso,
                idinventario:this.state.idinventario,
                urlfactura:this.state.urlfactura,
                urlmanual:this.state.urlmanual,
                urlmanualuser:this.state.urlmanualuser,
                urlimportacion:this.state.urlimportacion,
                fechainstalacion: this.state.fechainstalacion,
                garantia: this.state.garantia,
                fechainiciogarantia: this.state.fechainiciogarantia,
                fechafingarantia: this.state.fechafingarantia,
                velocidad: this.state.velocidad,
                capacidad: this.state.capacidad,
                tipouso: this.state.tipouso,
                pais: this.state.pais,
                descripcion: this.state.descripcion,
                nombrefabricante: this.state.nombrefabricante,
                emailfabricante: this.state.emailfabricante,
                telfabricante: this.state.telfabricante,
                rutinamto: this.state.rutinamto,
                recomendaciones: this.state.recomendaciones,
                accesorio: this.state.accesorio,
                accesorionombre1: this.state.accesorionombre1,
                accesorioref1: this.state.accesorioref1,
                accesorioserie1: this.state.accesorioserie1,
                accesorionombre2: this.state.accesorionombre2,
                accesorioref2: this.state.accesorioref2,
                accesorioserie2: this.state.accesorioserie2,
                accesorionombre3: this.state.accesorionombre3,
                accesorioref3: this.state.accesorioref3,
                accesorioserie3: this.state.accesorioserie3
             
          };
    
     this.props.editActivoDetails(newmobiliarioData,this.props.mobiliarioId);
   
  };


 


    render() {
        const { UI:{loading}}=this.props; 
        const {errors}=this.state;
        return (
            <div>
                <Fragment>
            <MyButton tip="Editar Información" onClick={this.handleOpen}>
            <FaPencilAlt color="#03178C" className="icon-crearcliente"/>
             </MyButton>
             <Dialog
             open={this.state.open}
             onClose={this.handleClose}
             fullWidth
             maxWidth="sm"
            >

{this.state.aprobado.mensaje ? (
              
              <div className='div-aprobado'>
                  <div className='div-icono-aprobado'>
                    <FaCheck color="#ffffff" className='icono-aprobado'/>
                  </div>
                  <h2 className='text-aprobado'>Reporte Cargado Exitosamente</h2>
              </div>
                
                ) : (<div>
              <DialogTitle>Editar Detalles del Activo</DialogTitle>
               
               <DialogContent>
                     
               <form>
                       <Accordion>
           <AccordionSummary
             expandIcon={<ExpandMoreIcon />}
             aria-controls="panel1a-content"
             id="panel1a-header"
           >
                <h4 className="text-title-accorion">Identificación del Activo</h4>
           </AccordionSummary>
           <AccordionDetails>
           <div className="flex-accordion">
       
          <TextField className="login-input-email"
                      required
                      type="text"
                      name="nombre"
                      id="nombre"
                      label="Nombre del Activo"
                      value={this.state.nombre}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.nombre}
                      error={errors.nombre?true:false}
                      />

                  <div className="input_divido">
                  <div className="input_divido_children">
                  <TextField className="login-input-email"
                                        required
                                        type="text"
                                        name="idinventario"
                                        id="idinventario"
                                        label="No. Inventario"
                                        value={this.state.idinventario}
                                        onChange={this.handleChange}
                                        fullWidth
                                        helperText={errors.idinventario}
                                        error={errors.idinventario?true:false}
                                        />
                    </div>
                    <div className="input_divido_children">
                    <TextField className="login-input-email"
                                        required
                                        type="text"
                                        name="serie"
                                        id="serie"
                                        label="Numero de Serie"
                                        value={this.state.serie}
                                        onChange={this.handleChange}
                                        fullWidth
                                        helperText={errors.serie}
                                        error={errors.serie?true:false}
                                        />
                    </div>
                    </div>
                            
                     
                      <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="text"
                      name="modelo"
                      id="modelo"
                      label="Modelo "
                      value={this.state.modelo}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.modelo}
                      error={errors.modelo?true:false}
                      />
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="text"
                      name="marca"
                      id="marca"
                      label="Marca "
                      value={this.state.marca}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.marca}
                      error={errors.marca?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>

                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="text"
                      name="ubicacion"
                      id="ubicacion"
                      label="Ubicación "
                      value={this.state.ubicacion}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.ubicacion}
                      error={errors.ubicacion?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="text"
                      name="servicio"
                      id="servicio"
                      label="Servicio"
                      value={this.state.servicio}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.servicio}
                      error={errors.servicio?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>

                    <div className="input_divido">
                    <div className="input_divido_children">
                      <FormControl className="formcontrol-nuevocliente"  error={errors.tipo?true:false}>
                            <InputLabel>Tipo Activo</InputLabel>
                            <Select
                            required
                         name="tipo"
                         id="tipo"
                         value={this.state.tipo}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value="mobiliario">Mobiliario</MenuItem>
                            <MenuItem value="industrial">Industrial</MenuItem>
                            <MenuItem value="automotriz">Automotriz</MenuItem>
                            <MenuItem value="computo">Computo</MenuItem>
                            <MenuItem value="electrodomestico">Electrodomestico</MenuItem>
                            <MenuItem value="ofimatico">Ofimatico</MenuItem>
                            <MenuItem value="seguridad">Seguridad</MenuItem>
                            <MenuItem value="telecomunicacion">Telecomunicación</MenuItem>
                            <MenuItem value="audiovisual">Audiovisual</MenuItem>
                            <MenuItem value="hidrosanitario">Hidrosanitario</MenuItem>
                            <MenuItem value="energia">Energía</MenuItem>
                            <MenuItem value="climatizacion">Climatización</MenuItem>
                            </Select>
                            <FormHelperText>{errors.tipo}</FormHelperText>
                        </FormControl>
                        </div>
                        <div className="input_divido_children">
                        <FormControl className="formcontrol-nuevocliente"  error={errors.tipouso?true:false}>
                            <InputLabel>Tipo de Uso</InputLabel>
                            <Select
                            required
                         name="tipouso"
                         id="tipouso"
                         value={this.state.tipouso}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value="Medico">Medico</MenuItem>
                            <MenuItem value="Basico">Básico</MenuItem>
                            <MenuItem value="Apoyo">Apoyo</MenuItem>
                            <MenuItem value="N/A">N/A</MenuItem>
                            </Select>
                            <FormHelperText>{errors.tipouso}</FormHelperText>
                        </FormControl>
                      <br/>
                        </div>
                        
                    
                      
                    </div>

                    
                 
                    
                      
               
                        

                        <div className="input_divido">
                      
                        <div className="input_divido_children">
                      <FormControl className="formcontrol-nuevocliente" error={errors.reqcalibracion?true:false}>
                            <InputLabel>Requiere Calibración</InputLabel>
                            <Select
                            required
                         name="reqcalibracion"
                         id="reqcalibracion"
                         value={this.state.reqcalibracion}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value="true">Si</MenuItem>
                            <MenuItem value="false">No</MenuItem>
                            
                            </Select>
                            <FormHelperText>{errors.reqcalibracion}</FormHelperText>
                        </FormControl>
                        </div>
                        </div>
                        
                        <div className="input_divido">
                      
                        <div className="input_divido_children">
                      <FormControl className="formcontrol-nuevocliente" error={errors.movilfijo?true:false}>
                            <InputLabel>¿Activo es Movil o Fijo?</InputLabel>
                            <Select
                            required
                         name="movilfijo"
                         id="movilfijo"
                         value={this.state.movilfijo}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value="Movil">Móvil</MenuItem>
                            <MenuItem value="Fijo">Fijo</MenuItem>
                            
                            </Select>
                            <FormHelperText>{errors.movilfijo}</FormHelperText>
                        </FormControl>
                        </div>
                        </div>

                        <div className="input_divido">
                        <TextField className="login-input-email"
                                                multiline
                                                type="Text"
                                                name="descripcion"
                                                id="descripcion"
                                                label="Breve Descripción de Uso"
                                                rows={4}
                                                value={this.state.descripcion}
                                                onChange={this.handleChange}
                                                fullWidth
                                                helperText={errors.descripcion}
                                                error={errors.descripcion?true:false}
                                              />
                        </div>
                        




          </div>
           
                       
   
             </AccordionDetails>
             </Accordion>
   
             <Accordion>
           <AccordionSummary
             expandIcon={<ExpandMoreIcon />}
             aria-controls="panel1a-content"
             id="panel1a-header"
           >
                <h4 className="text-title-accorion">Historial de Adquisición</h4>
           </AccordionSummary>
           <AccordionDetails>
           <div className="flex-accordion">
      
        <div className="input_divido">
                      <div className="input_divido_children">
                      <FormControl className="formcontrol-nuevocliente" error={errors.adquisicion?true:false}>
                            <InputLabel>Forma Adquisición</InputLabel>
                            <Select
                            required
                         name="adquisicion"
                         id="adquisicion"
                         value={this.state.adquisicion}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value="compra">Compra</MenuItem>
                            <MenuItem value="comodato">Comodato</MenuItem>
                            <MenuItem value="donacion">Donación</MenuItem>
                            <MenuItem value="leasing">Leasing</MenuItem>
                            <MenuItem value="otro">Otro</MenuItem>
                            </Select>
                            <FormHelperText>{errors.adquisicion}</FormHelperText>
                        </FormControl>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="costo"
                      id="costo"
                      label="Valor del Activo"
                      value={this.state.costo}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.costo}
                      error={errors.costo?true:false}
                      />
                      <br/>
                        </div>
                        </div>

                        
                       

                        <div className="input_divido">
                      <div className="input_divido_children">
                      <TextField className="login-input-email"
                      required
                      type="date"
                      name="fabricacion"
                      id="fabricacion"
                      label="Fecha Fabricación"
                      value={this.state.fabricacion}
                      onChange={this.handleChange}
                      min="2000-01-01" max="2026-01-01"
                      fullWidth
                      helperText={errors.fabricacion}
                      error={errors.fabricacion?true:false}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      />
                        <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="date"
                      name="fechaadquisicion"
                      id="fechaadquisicion"
                      label="Fecha de Adquisición"
                      value={this.state.fechaadquisicion}
                      onChange={this.handleChange}
                      min="2000-01-01" max="2022-01-01"
                      fullWidth
                      helperText={errors.fechaadquisicion}
                      error={errors.fechaadquisicion?true:false}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      />
                      <br/>
                        </div>
                        </div>

                        <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="date"
                      name="fechainstalacion"
                      id="fechainstalacion"
                      label="Fecha de Instalacion"
                      value={this.state.fechainstalacion}
                      onChange={this.handleChange}
                      min="2000-01-01" max="2026-01-01"
                      fullWidth
                      helperText={errors.fechainstalacion}
                      error={errors.fechainstalacion?true:false}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      />
                     
                      
                        </div>

                        <div className="input_divido_children">
                      <FormControl className="formcontrol-nuevocliente" error={errors.garantia?true:false}>
                            <InputLabel>¿Activo en Garantia?</InputLabel>
                            <Select
                            required
                         name="garantia"
                         id="garantia"
                         value={this.state.garantia}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value='true'>Si</MenuItem>
                            <MenuItem value='false'>No</MenuItem>
                            
                            </Select>
                            <FormHelperText>{errors.garantia}</FormHelperText>
                        </FormControl>
                        </div>

                        </div>

                        {/* Conditional rendering for warranty dates */}
                      {this.state.garantia === 'true' && (
                        <div className="input_divido">
                          <div className="input_divido_children">
                            <TextField className="login-input-email"
                              required
                              type="date"
                              name="fechainiciogarantia"
                              id="fechainiciogarantia"
                              label="Fecha Inicio de Garantia"
                              value={this.state.fechainiciogarantia}
                              onChange={this.handleChange}
                              min="2000-01-01" max="2026-01-01"
                              fullWidth
                              helperText={errors.fechainiciogarantia}
                              error={errors.fechainiciogarantia?true:false}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>
                          <div className="input_divido_children">
                            <TextField className="login-input-email"
                              required
                              type="date"
                              name="fechafingarantia"
                              id="fechafingarantia"
                              label="Fecha Final de Garantía"
                              value={this.state.fechafingarantia}
                              onChange={this.handleChange}
                              min="2000-01-01" max="2026-01-01"
                              fullWidth
                              helperText={errors.fechafingarantia}
                              error={errors.fechafingarantia?true:false}
                              InputLabelProps={{
                                shrink: true,
                              }}
                            />
                          </div>
                        </div>
                      )}

                        <div className="input_divido">
                      <div className="input_divido_children">
                      <TextField className="login-input-email"
                      required
                      type="text"
                      name="pais"
                      id="pais"
                      label="País de Fabricación"
                      value={this.state.pais}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.pais}
                      error={errors.pais?true:false}
                      />
                        <br/>
                        </div>

                        <div className="input_divido_children">
                      <TextField className="login-input-email"
                      required
                      type="text"
                      name="nombrefabricante"
                      id="nombrefabricante"
                      label="Nombre Fabricante"
                      value={this.state.nombrefabricante}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.nombrefabricante}
                      error={errors.nombrefabricante?true:false}
                      />
                        <br/>
                        </div>
                       
                        </div>

                        <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="telfabricante"
                      id="telfabricante"
                      label="Telefono Fabricante"
                      value={this.state.telfabricante}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.telfabricante}
                      error={errors.telfabricante?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="email"
                      name="emailfabricante"
                      id="emailfabricante"
                      label="Email Fabricante"
                      value={this.state.emailfabricante}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.emailfabricante}
                      error={errors.emailfabricante?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>

                        <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="vidautil"
                      id="vidautil"
                      label="Años de Vida Útil"
                      value={this.state.vidautil}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.vidautil}
                      error={errors.vidautil?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="text"
                      name="proveedor"
                      id="proveedor"
                      label="Proveedor"
                      value={this.state.proveedor}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.proveedor}
                      error={errors.proveedor?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>

                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="proveedortel"
                      id="proveedortel"
                      label="Telefono Proveedor"
                      value={this.state.proveedortel}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.proveedortel}
                      error={errors.proveedortel?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="email"
                      name="proveedoremail"
                      id="proveedoremail"
                      label="Email proveedor"
                      value={this.state.proveedoremail}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.proveedoremail}
                      error={errors.proveedoremail?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>
                    </div>
   
           </AccordionDetails>
   
   
    
             </Accordion>
   
             <Accordion>
           <AccordionSummary
             expandIcon={<ExpandMoreIcon />}
             aria-controls="panel1a-content"
             id="panel1a-header"
           >
                <h4 className="text-title-accorion">Datos Técnicos</h4>
           </AccordionSummary>
           <AccordionDetails>
           <div className="flex-accordion">
       
        <FormControl className="formcontrol-nuevocliente">
                            <InputLabel>Tecnología Predominante</InputLabel>
                            <Select
                            required
                         name="tipotec"
                         id="tipotec"
                         value={this.state.tipotec}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value="Electrónica">Electrónica</MenuItem>
                            <MenuItem value="Eléctrica">Eléctrica</MenuItem>
                            <MenuItem value="Mecánica">Mecánica</MenuItem>
                            <MenuItem value="Hidraulica">Hidraulica</MenuItem>                            
                            <MenuItem value="Neumatica">Neumatica</MenuItem>
                            <MenuItem value="Vapor">Vapor</MenuItem>
                            <MenuItem value="Otra">Otra</MenuItem>
                            </Select>
                            <FormHelperText>{errors.tipotec}</FormHelperText>
                        </FormControl>

                        <FormControl className="formcontrol-nuevocliente">
                            <InputLabel>Fuente de Alimentación</InputLabel>
                            <Select
                            required
                         name="fuente"
                         id="fuente"
                         value={this.state.fuente}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value="AC">AC</MenuItem>
                            <MenuItem value="DC">DC </MenuItem>
                            <MenuItem value="Gas Medicinal">Gas Medicinal</MenuItem>
                            <MenuItem value="Agua">Agua</MenuItem>        
                            <MenuItem value="Aire">Aire</MenuItem>                    
                            <MenuItem value="Aire comprimido">Aire comprimido</MenuItem>
                            <MenuItem value="Energia Solar">Energia Solar</MenuItem>
                            <MenuItem value="Derivados del Petroleo">Derivados del Petroleo</MenuItem>
                            <MenuItem value="Vapor">Vapor</MenuItem>
                            <MenuItem value="Otra">Otra</MenuItem>
                            </Select>
                            <FormHelperText>{errors.tipotec}</FormHelperText>
                        </FormControl>

                        <TextField className="login-input-email"
                      required
                      type="tex"
                      name="urlmanual"
                      id="urlmanual"
                      label="Link del Manual o Ficha Técnica"
                      value={this.state.urlmanual}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.urlmanual}
                      error={errors.urlmanual?true:false}
                      />

              <TextField className="login-input-email"
                      required
                      type="tex"
                      name="urlfactura"
                      id="urlfactura"
                      label="Link de Factura o Declaración de Importación"
                      value={this.state.urlfactura}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.urlfactura}
                      error={errors.urlfactura?true:false}
                      />

                        <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="tensionmin"
                      id="tensionmin"
                      label="Tensión Min (V)"
                      value={this.state.tensionmin}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.tensionmin}
                      error={errors.tensionmin?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="tensionmax"
                      id="tensionmax"
                      label="Tensión Max (V)"
                      value={this.state.tensionmax}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.tensionmax}
                      error={errors.tensionmax?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>


                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="corrientemin"
                      id="corrientemin"
                      label="Corriente Min (A)"
                      value={this.state.corrientemin}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.corrientemin}
                      error={errors.corrientemin?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="corrientemax"
                      id="corrientemax"
                      label="Corriente Max (A)"
                      value={this.state.corrientemax}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.corrientemax}
                      error={errors.corrientemax?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>


                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="velocidad"
                      id="velocidad"
                      label="Velocidad"
                      value={this.state.velocidad}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.velocidad}
                      error={errors.velocidad?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="potencia"
                      id="potencia"
                      label="Potencia  (W)"
                      value={this.state.potencia}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.potencia}
                      error={errors.potencia?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>
                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="presion"
                      id="presion"
                      label="Presion"
                      value={this.state.presion}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.presion}
                      error={errors.presion?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="capacidad"
                      id="capacidad"
                      label="Capacidad"
                      value={this.state.capacidad}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.capacidad}
                      error={errors.capacidad?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>

                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="temperatura"
                      id="temperatura"
                      label="Temperatura de Operación"
                      value={this.state.temperatura}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.temperatura}
                      error={errors.temperatura?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="frecuencia"
                      id="frecuencia"
                      label="Frecuencia(Hz)"
                      value={this.state.frecuencia}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.frecuencia}
                      error={errors.frecuencia?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>


                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="alto"
                      id="alto"
                      label="Medidas Alto (cm)"
                      value={this.state.alto}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.alto}
                      error={errors.alto?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="ancho"
                      id="ancho"
                      label="Medidas Ancho (cm)"
                      value={this.state.ancho}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.ancho}
                      error={errors.ancho?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>

                    <div className="input_divido">
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="largo"
                      id="largo"
                      label="Medidas Largo (cm)"
                      value={this.state.largo}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.largo}
                      error={errors.largo?true:false}
                      />
                      <br/>
                        </div>
                        <div className="input_divido_children">
                        <TextField className="login-input-email"
                      required
                      type="number"
                      name="peso"
                      id="peso"
                      label="Peso (Kg)"
                      value={this.state.peso}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.peso}
                      error={errors.peso?true:false}
                      />
                      <br/>
                        </div>
                    
                      
                    </div>

                  

                      
                           
                         




          </div>
             </AccordionDetails>
             </Accordion>
                   
   
   
             <Accordion>
           <AccordionSummary
             expandIcon={<ExpandMoreIcon />}
             aria-controls="panel1a-content"
             id="panel1a-header"
           >
                <h4 className="text-title-accorion">Información Adicional</h4>
           </AccordionSummary>
           <AccordionDetails>

           <div className="flex-accordion">
        
          <div className="input_divido">
                        <TextField className="login-input-email"
                                                multiline
                                                type="Text"
                                                name="rutinamto"
                                                id="rutinamto"
                                                label="Rutina de Mantenimiento"
                                                rows={4}
                                                value={this.state.rutinamto}
                                                onChange={this.handleChange}
                                                fullWidth
                                                helperText={errors.rutinamto}
                                                error={errors.rutinamto?true:false}
                                              />
                        </div>

                        <div className="input_divido">
                        <TextField className="login-input-email"
                                                multiline
                                                type="Text"
                                                name="recomendaciones"
                                                id="recomendaciones"
                                                label="Recomendaciones de Uso"
                                                rows={4}
                                                value={this.state.recomendaciones}
                                                onChange={this.handleChange}
                                                fullWidth
                                                helperText={errors.recomendaciones}
                                                error={errors.recomendaciones?true:false}
                                              />
                        </div>
          <div className="input_divido">
                        <FormControl className="formcontrol-nuevocliente" error={errors.garantia?true:false}>
                            <InputLabel>¿El activo tiene accesorios?</InputLabel>
                            <Select
                            required
                         name="accesorio"
                         id="accesorio"
                         value={this.state.accesorio}
                            onChange={this.handleChange}
                            fullWidth
                            >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            <MenuItem value='true'>Si</MenuItem>
                            <MenuItem value='false'>No</MenuItem>
                            
                            </Select>
                            <FormHelperText>{errors.accesorio}</FormHelperText>
                        </FormControl>
                        </div>
{/* accesorionombre1:'',
            accesorioref1:'',
            accesorioserie1:'', */}
                            {this.state.accesorio === 'true' && (
                               <>
 <div className="input_divido">
                        <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorionombre1"
                      id="accesorionombre1"
                      label="Nombre Accesorio 1"
                      value={this.state.accesorionombre1}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorionombre1}
                      error={errors.accesorionombre1?true:false}
                      />
                          </div>

                          <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorioref1"
                      id="accesorioref1"
                      label="Referencia"
                      value={this.state.accesorioref1}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorioref1}
                      error={errors.accesorioref1?true:false}
                      />
                          </div>

                          <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorioserie1"
                      id="accesorioserie1"
                      label="Serie"
                      value={this.state.accesorioserie1}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorioserie1}
                      error={errors.accesorioserie1?true:false}
                      />
                          </div>

                          </div>

                          <div className="input_divido">
                        <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorionombre2"
                      id="accesorionombre2"
                      label="Nombre Accesorio 2"
                      value={this.state.accesorionombre2}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorionombre2}
                      error={errors.accesorionombre2?true:false}
                      />
                          </div>

                          <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorioref2"
                      id="accesorioref2"
                      label="Referencia"
                      value={this.state.accesorioref2}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorioref2}
                      error={errors.accesorioref2?true:false}
                      />
                          </div>

                          <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorioserie2"
                      id="accesorioserie2"
                      label="Serie"
                      value={this.state.accesorioserie2}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorioserie2}
                      error={errors.accesorioserie2?true:false}
                      />
                          </div>

                          </div>

                          <div className="input_divido">
                        <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorionombre3"
                      id="accesorionombre3"
                      label="Nombre Accesorio 3"
                      value={this.state.accesorionombre3}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorionombre3}
                      error={errors.accesorionombre3?true:false}
                      />
                          </div>

                          <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorioref3"
                      id="accesorioref3"
                      label="Referencia"
                      value={this.state.accesorioref3}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorioref3}
                      error={errors.accesorioref3?true:false}
                      />
                          </div>

                          <div className="input_divido_children">
                          <TextField className="login-input-email"
                      required
                      type="tex"
                      name="accesorioserie3"
                      id="accesorioserie3"
                      label="Serie"
                      value={this.state.accesorioserie3}
                      onChange={this.handleChange}
                      fullWidth
                      helperText={errors.accesorioserie3}
                      error={errors.accesorioserie3?true:false}
                      />
                          </div>

                          </div>
                            </>

                            )}
          </div>
        


           </AccordionDetails>
           </Accordion>
                          
   
   
   
   
               </form>
                            
               </DialogContent>
                </div>)
                }

            
            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleClose}>
            <FaArrowLeft color="#D3D7DC" className="icon-formulario"/>
             </MyButton>

             {loading ? (
                <CircularProgress size={30} color="primary" className="login-progress" />
              ) : (
                this.state.aprobado.mensaje ? (
                  <MyButton tip="Continuar" onClick={this.handleClose}>
                    <FaCheckCircle color="#20B90C" className="icon-formulario" />
                  </MyButton>
                ) : (
                  <MyButton tip="Actualizar Información" onClick={this.handleSubmit}>
                  <FaPlus  color="#03178C" className="icon-formulario"/>
                   </MyButton>
                )
              )}
         
            
            
          </DialogActions>

            </Dialog>
             </Fragment>

            </div>
        )
    }
}

DetallesActivo.propTypes = {
    editActivoDetails: PropTypes.func.isRequired,
    getActivo:PropTypes.func.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired  
  };

  const mapActionsToProps={editActivoDetails,getActivo,clearErrors};

  const mapStateToProps = (state) => ({
    mobiliario: state.dataMob.mobiliario.credentials,
    UI:state.UI
  });
  
  export default connect(mapStateToProps,mapActionsToProps)(DetallesActivo);
